import {
    AUTH_SOURCE_TYPE_PULSE,
    AUTH_SOURCE_TYPE_SPID,
} from '../constants';

const isUserAuthenticated = state => state.login.authenticated;

const getAuthenticationType = state => state.login.source;

const isLoggedInWithSPiD = state => state.login.source === AUTH_SOURCE_TYPE_SPID;

const isLoggedInWithPulse = state => state.login.source === AUTH_SOURCE_TYPE_PULSE;

const isLoginInitialized = state => state.login.initialized;

const getUserId = state => state.login.subjectId;

const getUserEmail = state => state.login.email;

const getUserNames = ({ spid: { displayName, familyName, givenName } }) => ({
    displayName,
    familyName,
    givenName,
});

const getLogin = state => state.spid.login;

const getIsTpaasEnabled = state => state.login.isTpaasEnabled || false;

export default {
    isUserAuthenticated,
    getAuthenticationType,
    isLoggedInWithSPiD,
    isLoggedInWithPulse,
    getUserId,
    getUserEmail,
    getUserNames,
    isLoginInitialized,
    getLogin,
    getIsTpaasEnabled,
};
